import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading'

class KoyouSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false}
    this.systemSettingName = 'KoyouSetting'
  }
  onInsert (offset) {
    offset = Number(offset)
    const koyouRyouritsuList = this.getSettingData()
    koyouRyouritsuList.splice(offset + 1, 0,
      {
        startMonth: this.getIntYM(),
        endMonth: this.getIntYM(),
        honninRyouritsu: null,
        koyounushiRyouritsu: null
      }
    )
    this.setState({
      KoyouSetting: koyouRyouritsuList,
      KoyouSettingInputData: JSON.parse(JSON.stringify(koyouRyouritsuList))
    })
  }
  onDelete (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const koyouRyouritsuList = this.getSettingData()
        koyouRyouritsuList.splice(offset, 1)
        this.setState({
          KoyouSetting: koyouRyouritsuList,
          KoyouSettingInputData: JSON.parse(JSON.stringify(koyouRyouritsuList))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const koyouRyouritsuList = this.getSettingData()
      koyouRyouritsuList.splice(offset - 1, 2, koyouRyouritsuList[offset], koyouRyouritsuList[offset - 1])
      this.setState({
        KoyouSetting: koyouRyouritsuList,
        KoyouSettingInputData: JSON.parse(JSON.stringify(koyouRyouritsuList))
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    const koyouRyouritsuList = this.getSettingData()
    if (offset < koyouRyouritsuList.length - 1) {
      offset++
      koyouRyouritsuList.splice(offset - 1, 2, koyouRyouritsuList[offset], koyouRyouritsuList[offset - 1])
      this.setState({
        KoyouSetting: koyouRyouritsuList,
        KoyouSettingInputData: JSON.parse(JSON.stringify(koyouRyouritsuList))
      })
    }
  }
  getEditor (index, attributeName) {
    const value = this.state.KoyouSettingInputData[index][attributeName] ? this.state.KoyouSettingInputData[index][attributeName] : ''
    return (
      <input type='text' name={attributeName} value={value} onChange={(e) => this.changeKoyouData(index, attributeName, e)} />
    )
  }
  changed (index, attributeName, e) {
    const KoyouSetting = this.state.KoyouSetting
    KoyouSetting[index][attributeName] = parseInt(e.target.value)
    this.setState({
      KoyouSetting: KoyouSetting,
      KoyouSettingInputData: JSON.parse(JSON.stringify(KoyouSetting))
    })
  }
  changeKoyouData (index, attributeName, e) {
    const KoyouSetting = this.state.KoyouSetting
    const KoyouSettingInputData = this.state.KoyouSettingInputData
    let changedValue = e.target.value

    // 数値と少点数以外を除く
    changedValue = changedValue.replace(/[^0-9.]/g, '')
    // input用データ
    KoyouSettingInputData[index][attributeName] = changedValue
    // 保存用データ（小数を含む整数にする）
    KoyouSetting[index][attributeName] = parseFloat(changedValue)
    this.setState({
      KoyouSetting: KoyouSetting,
      KoyouSettingInputData: KoyouSettingInputData
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const koyouRyouritsuList = this.getSettingData()
    const yearMonthList = this.getYMList(6, 201509).reverse()
    const yearMonthListToShow = []
    yearMonthList.forEach(ym => {
      yearMonthListToShow.push(
        <option key={this.uuid()} value={ym.id}>{ym.name}</option>
      )
    })
    const koyouRyouritsuListToShow =
    koyouRyouritsuList.map((koyouRyouritsu, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td><select value={koyouRyouritsu.startMonth} onChange={(e) => this.changed(index, 'startMonth', e)} >{yearMonthListToShow}</select></td>
          <td><select value={koyouRyouritsu.endMonth} onChange={(e) => this.changed(index, 'endMonth', e)} >{yearMonthListToShow}</select></td>
          <td>{this.getEditor(index, 'honninRyouritsu')}</td>
          <td>{this.getEditor(index, 'koyounushiRyouritsu')}</td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsert.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDelete.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUp.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDown.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>雇用保険</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            <table>
              <thead>
                <tr>
                  <th className='kw-ds-no' />
                  <th className='kw-ds-start-month' />
                  <th className='kw-ds-end-month' />
                  <th className='kw-ds-honnin-ryouritsu' />
                  <th className='kw-ds-koyounushi-ryouritsu' />
                  <th className='kw-ds-gyou-sousa' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className='kw-ds-no'>No.</th>
                  <th>適用開始年月</th>
                  <th>適用終了年月</th>
                  <th>本人負担率</th>
                  <th>雇用主負担率</th>
                  <th className='kw-ds-gyou-sousa'>行操作</th>
                </tr>
                {koyouRyouritsuListToShow}
              </tbody>
            </table>
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default KoyouSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/KoyouSetting.js